import styled, { css } from 'styled-components'
import { Button } from '@sainsburys-tech/bolt'
import { createCSSObject, colorToLunaToken } from '../../../helpers/theming/utilities'
import { LinkWrapper } from '../../../helpers/StyledWrappers.styles'
import { C003StyledContainer, C003StyledCTAContainer, C003StyledCTA, C003StyledHeadings } from './types'

const hasIconMargin = (props, spacing) => (props.hasIcon ? props.theme.size.spacing[spacing] : 0)
const wrapperCSS = css<C003StyledContainer>`
  display: flex;
  width: 100%;
  flex-direction: row;
  flex-wrap: wrap;
  text-decoration: none;
  position: relative;
  ${(props) =>
    css`
      min-height: ${props.theme.channel === 'sainsburys' ? 'unset' : '90px'};
      justify-content: ${props.theme.channel === 'sainsburys' ? 'flex-start' : 'center'};
      text-align: ${props.theme.channel === 'sainsburys' ? 'left' : 'center'};
      padding: ${props.theme.size.spacing.lg};
      margin-bottom: ${props.theme.size.spacing.lg};
      background-color: ${colorToLunaToken(props.backgroundColour, props.theme) ||
      props.theme.color.monochrome.lighter};
    `}
`

const StyledWrapperAnchor = styled.div`
  ${wrapperCSS}
  ${LinkWrapper}
`

const StyledWrapperDiv = styled.div`
  ${wrapperCSS}
`

const StyledHeadings = styled.div<C003StyledHeadings>`
  color: ${(props) => colorToLunaToken(props.textColor, props.theme) || props.theme.color.monochrome.darker};
  display: flex;
  margin-bottom: 0;
  justify-content: center;
  align-items: ${(props) => (props.theme.channel === 'sainsburys' ? 'flex-start' : 'center')};
  flex-direction: column;
  flex: 0 0 100%;
  width: 100%;

  ${(props) =>
    props.hasOneCTA &&
    css`
      @media screen and (min-width: ${props.theme.size.breakpoint['min-width'].md}) {
        padding-left: ${props.theme.channel === 'sainsburys' ? '0' : '12%'};
      }
    `}

  h4,
  p {
    margin-bottom: 0;
  }

  h4 {
    ${(props) => props.theme.channel === 'sainsburys' && createCSSObject(props.theme.font.stack['label-2'])};
    margin-left: ${(props) => (props.hasIcon ? props.theme.size.spacing.md : 0)};
  }

  p {
    margin-left: ${(props) => hasIconMargin(props, ['2xl'])};
  }

  @media screen and (min-width: ${(props) => props.theme.size.breakpoint['min-width'].md}) {
    max-width: ${(props) => (props.hasOneCTA ? '83.3333%' : '100%')};
  }
`

const StyledCTAContainer = styled.div<C003StyledCTAContainer>`
  color: ${(props) => colorToLunaToken(props.textColor, props.theme) || props.theme.color.monochrome.darker};
  display: flex;
  justify-content: ${(props) => (props.theme.channel === 'sainsburys' ? 'flex-start' : 'center')};
  align-items: center;
  margin-left: ${(props) => hasIconMargin(props, 'md')};
  flex: 0 0 100%;
  max-width: 100%;

  @media screen and (min-width: ${(props) => props.theme.size.breakpoint['min-width'].md}) {
    ${(props) =>
      props.hasOneCTA
        ? css`
            justify-content: flex-end;
            max-width: 16.6%;
            margin-left: 0;
          `
        : css`
            justify-content: ${props.theme.channel !== 'sainsburys' && 'center'};
            margin-left: ${props.hasIcon && props.theme.size.spacing['2xl']};
            margin-left: ${props.theme.channel === 'sainsburys'
              ? hasIconMargin(props, ['2xl'])
              : hasIconMargin(props, 'xl')};
          `}
  }

  ${(props) =>
    css`
      @media screen and (max-width: ${props.theme.size.breakpoint['max-width'].sm}) {
        align-items: stretch;
        flex-direction: ${props.kind === 'link' ? 'row' : 'column'};
        max-width: 100%;
        ${
          props.hasIcon &&
          css`
            margin-left: ${props.theme.size.spacing['2xl']};
            max-width: 90%;
          `
        }
  `}
`

const StyledCTA = styled.span<C003StyledCTA>`
  ${(props) =>
    css`
      font-weight: ${props.theme.font.weight.bold};
      text-decoration: ${props.theme.channel === 'sainsburys' ? 'underline' : 'none'};
      ${!props.hasOneCTA &&
      css`
        margin-left: ${props.theme.channel !== 'sainsburys' && props.theme.size.spacing.md};
        margin-right: ${props.theme.channel === 'sainsburys'
          ? props.theme.size.spacing.lg
          : props.theme.size.spacing.md};
      `}

      @media screen and (min-width: ${props.theme.size.breakpoint['min-width'].md}) {
        display: flex;
      }
    `}
`

const StyledButton = styled(Button)`
  ${(props) => css`
    background-color: ${colorToLunaToken(props.buttonColor, props.theme)};
    color: ${colorToLunaToken(props.buttonTextColor, props.theme)};

    @media screen and (min-width: ${props.theme.size.breakpoint['min-width'].md}) {
      margin-left: ${props.theme.channel !== 'sainsburys' && props.theme.size.spacing.md};
      margin-right: ${props.theme.channel === 'sainsburys' ? props.theme.size.spacing.lg : props.theme.size.spacing.md};
    }
  `}
`

const StyledHeadingWrapper = styled.div`
  display: flex;
  justify-content: center;
`

const StyledIconWrapper = styled.div`
  ${(props) =>
    css`
      width: ${props.theme.size.spacing.xl};
    `}
`

export {
  StyledWrapperAnchor,
  StyledWrapperDiv,
  StyledHeadings,
  StyledCTAContainer,
  StyledCTA,
  StyledButton,
  StyledHeadingWrapper,
  StyledIconWrapper
}
